import _get from 'lodash/get';

// @ts-ignore
var space = (function (_scalar, _scaleType) {
  if (_scaleType === void 0) {
    _scaleType = 'minor';
  }

  return function (props) {
    var scalar = _scalar;
    var scaleType = _scaleType;
    if (!scalar) return 0;

    if (typeof scalar === 'string' && (scalar.includes('minor') || scalar.includes('major'))) {
      // @ts-ignore
      var _scalar$split = scalar.split('-');

      scaleType = _scalar$split[0];
      scalar = _scalar$split[1];
      scalar = parseFloat(scalar);
      if (isNaN(scalar)) return 0;
    }

    var unit = _get(props, "theme.fannypack.layout." + scaleType + "Unit");

    var fontSize = _get(props, 'theme.fannypack.global.fontSize');

    return scalar * (unit / fontSize);
  };
});

export default space;
